module.exports = "tbody > tr > td {\n  padding: 10px; }\n\ntr:nth-child(even) {\n  background-color: #f9f9f9; }\n\n.name-cell-dynamic {\n  width: 350px; }\n  @media screen and (max-width: 1199px) {\n    .name-cell-dynamic {\n      width: 325px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/lead-sources-section/lead-sources-section.scss
// module id = ./web/modern/components/settings/lead-sources-section/lead-sources-section.scss
// module chunks = 0